/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type V1DeployCreateDeploymentResponseData = {
  /**
   * Unique deployment identifier
   */
  deploymentId: string;
};

/** @internal */
export const V1DeployCreateDeploymentResponseData$inboundSchema: z.ZodType<
  V1DeployCreateDeploymentResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  deploymentId: z.string(),
});

export function v1DeployCreateDeploymentResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1DeployCreateDeploymentResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      V1DeployCreateDeploymentResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1DeployCreateDeploymentResponseData' from JSON`,
  );
}
